import React from 'react';
import { RenderCheckBoxField } from '@zola/zola-ui/src/components/Form/RenderCheckBoxField';
import classNames from 'classnames';
import propTypes from 'prop-types';

import CustomLabel from './CustomLabel';
import './CheckboxList.less';

export const Checkbox = ({ filters, apiKeyName, value, count, label, onChange }) => {
  const isActive = Boolean(filters && filters[value]);
  const checkboxBorderClassName = classNames('checkbox-list__section', {
    'checkbox-list__section--active': isActive,
  });

  return (
    <RenderCheckBoxField
      className={checkboxBorderClassName}
      key={value}
      type="checkbox"
      id={value}
      labelElem={
        <CustomLabel
          isActive={isActive}
          value={value}
          apiKeyName={apiKeyName}
          label={label}
          count={count}
        />
      }
      input={{
        checked: isActive,
        onChange,
      }}
      meta={{ touched: true }}
    />
  );
};

Checkbox.propTypes = {
  filters: propTypes.shape({}),
  apiKeyName: propTypes.string,
  value: propTypes.string,
  count: propTypes.number,
  label: propTypes.string,
  onChange: propTypes.func,
};

export default Checkbox;
